import { isAgent, getPartnerGuid, hasAuthourity } from '../../../lib/access.es6'
import { PARTNERS_GUID_ENUM } from '../../../routes/PartnersEnum'

// Is the current user an OMK agent, rather than an OMK back-office operator?
//
// The partner check is bundled in deliberately. The screens this gates are
// shared with a dozen other partners — the Mzanu home page, AccessBank's policy
// processing, PolicyDetailsFlp (also OM Uganda FLP) — so a bare isAgent() at
// those call sites would reshape their UI too.
//
// Keycloak groups are never read into the session (login flattens
// realm_access.roles into authorities), so OMK_AGENT_BRANCH and
// OMK_AGENT_CALL_CENTER are indistinguishable here. Both resolve to this one
// agent view, which is what the distribution brief asks for.
//
// getPartnerGuid() reads localStorage on every call, so call this from a
// render/lifecycle body — never at module scope, where it would freeze at the
// partner that happened to be active at import time.
//
// Inclusivity staff (CREATE_PARTNER comes only from ROLE_ADMIN, ROLE_IM and
// INCLUSIVITY_TEAM_SUPPORT) never get the lockdown, so an admin who ticks
// "Is Agent?" on themselves to try the agent flow keeps the full app.
export function isOmkAgent() {
  return (
    getPartnerGuid() === PARTNERS_GUID_ENUM.OLDMUTUAL_KENYA &&
    isAgent() &&
    !hasAuthourity('CREATE_PARTNER')
  )
}

// Everything an OMK agent may open, matched as a prefix on the path after
// /admin/. An allowlist rather than a blocklist: a route added to the app later
// is closed to agents until it is named here, which is the safe direction for a
// lockdown — the alternative leaks every new admin page by default.
const OMK_AGENT_PATHS = [
  '',
  'home',
  'admin-home',
  'commissions/my',
  'knowledge_base',
  'generate-policy',
  'create-quote',
  'policy-processing',
  'agent-policies',
  // The brief's "Policy Number > Find policy" step. NOTE: this search is not
  // agent-scoped — an agent can look up any policy on the partner. Scoping it
  // needs the search service to filter on the acting agent.
  'search',
  // Reachable from the "View Customer Details" button on the policy tab, and
  // needs a guid, so it is not enumerable.
  'customer_status',
  'profile',
  'settings',
  'alerts'
]

export function isPathAllowedForOmkAgent(pathname) {
  const rest = String(pathname || '')
    .replace(/^\/?admin\/?/, '')
    .replace(/\/$/, '')

  for (let i = 0; i < OMK_AGENT_PATHS.length; i++) {
    const allowed = OMK_AGENT_PATHS[i]
    if (rest === allowed) {
      return true
    }
    if (allowed && rest.indexOf(`${allowed}/`) === 0) {
      return true
    }
  }
  return false
}
